import { render } from "./ConfirmarCodigo.vue?vue&type=template&id=1c8a94ff"
import script from "./ConfirmarCodigo.vue?vue&type=script&lang=js"
export * from "./ConfirmarCodigo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__